import React, { lazy, Suspense } from 'react';
import { Box, Flex, Spinner } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

// Lazy-load the heavy chat container (same as the route does)
const BubChatContainer = lazy(() => import('./BubChatContainer'));

/**
 * ChatPanel — Floating persistent chat panel for desktop.
 *
 * • Fixed position, right side of screen, below navbar (80px top offset — actual desktop navbar height)
 * • ~390px wide — same as a mobile viewport, so mobile-first chat design fits perfectly
 * • Slides in from the right when open, hidden off-screen when closed
 * • Rendered in App.js (outside Routes) so it persists across navigation
 * • Mobile: display:none — on mobile the full /chat route is used instead
 */
const ChatPanel = () => {
  const chatPanelOpen = useSelector(state => state.chat?.chatPanelOpen) || false;

  return (
    <Box
      /* Only show on md+ screens — mobile uses the full /chat route */
      display={{ base: 'none', md: 'flex' }}
      flexDirection="column"
      position="fixed"
      top="80px"
      right={chatPanelOpen ? '0' : '-410px'}
      width="390px"
      height="calc(100vh - 80px)"
      zIndex={200}
      transition="right 0.25s cubic-bezier(0.4, 0, 0.2, 1)"
      boxShadow="-6px 0 32px rgba(0, 0, 0, 0.6)"
      borderLeft="1px solid rgba(255,255,255,0.06)"
      overflow="hidden"
      bg="#0D1117"
    >
      {/* Chat content — fills full panel height, tab bar inside BubChatContainer is the header */}
      <Box flex="1" overflow="hidden" position="relative" height="100%">
        {chatPanelOpen && (
          <Suspense fallback={
            <Flex justify="center" align="center" height="100%">
              <Spinner color="#ECC94B" size="lg" />
            </Flex>
          }>
            <BubChatContainer isPanel={true} />
          </Suspense>
        )}
      </Box>
    </Box>
  );
};

export default ChatPanel;
